// Copyright (c) Ping. All rights reserved.
//
// Local-only types for the redesigned shared Settings modal (v2). This
// mirrors `apps/web/src/features/settings/web/types.ts` exactly — the
// web variant kept the type local because it modeled the BE-facing
// surface (display name, avatar, devices) rather than the legacy
// `@ping/ui` `SettingsValues` / `SettingsCallbacks`. v2 stays compatible
// with that shape so the web host can migrate later without prop
// renames.
//
// `WebSettingsTabId` is renamed to `SettingsTabId` here — there's
// nothing web-specific about it.

export type SettingsTabId =
	| "account"
	| "session"
	| "appearance"
	| "notifications"
	| "preferences"
	| "keyboard"
	| "sidebar"
	| "voiceVideo"
	| "storage"
	| "securityPrivacy"
	| "encryption"
	| "linking"
	| "recovery"
	| "helpAbout";

export const SETTINGS_TAB_ORDER: readonly SettingsTabId[] = [
	"account",
	"session",
	"appearance",
	"notifications",
	"preferences",
	"keyboard",
	"sidebar",
	"voiceVideo",
	"storage",
	"securityPrivacy",
	"encryption",
	"linking",
	"recovery",
	"helpAbout",
] as const;

export const SETTINGS_TAB_LABELS: Record<SettingsTabId, string> = {
	account: "Account",
	session: "Session",
	appearance: "Appearance",
	notifications: "Notifications",
	preferences: "Preferences",
	keyboard: "Keyboard",
	sidebar: "Sidebar",
	voiceVideo: "Voice & Video",
	storage: "Storage",
	securityPrivacy: "Security & Privacy",
	encryption: "Encryption",
	linking: "Linked devices",
	recovery: "Account recovery",
	helpAbout: "Help & About",
};
